import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-pop-up-footer',
  templateUrl: './pop-up-footer.component.html',
  styleUrls: ['./pop-up-footer.component.scss']
})
export class PopUpFooterComponent {

  @Output() saveEvent = new EventEmitter();
  @Output() closeEvent = new EventEmitter();
  @Input() disabledButton: boolean = false;

  close() {

    this.closeEvent.emit();
  }

  save() {

    this.saveEvent.emit();
  }
}
